import { combineReducers } from 'redux';

import app from 'app/common/reducers/app';
import t from 'app/common/reducers/t';
import flags from 'app/common/reducers/flags';
import auth from 'app/common/reducers/auth';
import inAppMessages from 'app/common/reducers/inAppMessages';
import notifications from 'app/common/reducers/notifications';
import location from 'app/common/reducers/location';
import recentLocations from 'app/common/reducers/recentLocations';
import recentSearches from 'app/common/reducers/recentSearches';
import dealSearch from 'app/common/reducers/dealSearch';
import dealSuggestions from 'app/common/reducers/dealSuggestions';
import locationSearch from 'app/common/reducers/locationSearch';
import locationSuggestions from 'app/common/reducers/locationSuggestions';
import search from 'app/common/reducers/search';

const rootReducer = combineReducers({
  app,
  t,
  auth,
  flags,
  inAppMessages,
  notifications,
  location,
  recentLocations,
  recentSearches,
  dealSearch,
  dealSuggestions,
  locationSearch,
  locationSuggestions,
  search,
});

export default rootReducer;
